import * as Yup from 'yup';
import { latinUmlautSpaceNumberDotCommaRegex } from 'src/helpers/regexHelpers';
import { WORKSPACE_ACTIONS, WORKSPACE_FIELDS } from 'src/constants/workspacesConstants';
import { TUserAccessForm, TWorkspaceNameForm } from 'src/interfaces/WorkspacesTypes';

export const workspaceNameValidationSchema: Yup.ObjectSchema<TWorkspaceNameForm, Record<string, string>> = Yup.object({
  [WORKSPACE_FIELDS.NAME]: Yup.string()
    .required('Workspace Name cannot be blank')
    .matches(latinUmlautSpaceNumberDotCommaRegex, 'Please, use only Latin, numbers, dots or commas')
    .trim()
    .min(3, 'Name field should be 3-255 chars long')
    .max(255, 'Name field should be 3-255 chars long')
});

const grantUserAccessValidationSchema: Yup.ObjectSchema<TUserAccessForm, Record<string, string>> = Yup.object({
  [WORKSPACE_FIELDS.EMAIL]: Yup.string()
    .email('Wrong format. Please, enter the email as “your@email.com”')
    .required('Email cannot be blank'),

  [WORKSPACE_FIELDS.ACCESS]: Yup.string().required('Access Level cannot be empty')
});

const editUserAccessValidationSchema: Yup.ObjectSchema<TUserAccessForm, Record<string, string>> = Yup.object({
  [WORKSPACE_FIELDS.ACCESS]: Yup.string().required('Access Level cannot be empty')
});

export const userAccessValidationSchema = {
  [WORKSPACE_ACTIONS.GRANT_ACCESS]: grantUserAccessValidationSchema,
  [WORKSPACE_ACTIONS.EDIT_ACCESS]: editUserAccessValidationSchema
};
